import React, {useCallback, useMemo, useState} from "react";
import "./index.scss";
import LoggedOutLayout from "features/layouts/pages/logged-out";
import Modal from "features/components/modal";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import Button from "features/components/button";
import {connect} from "react-redux";
import PasswordTextField from "features/components/password-text-field";
import {PasswordValidator} from "services/utils/validations";
import {
    resetPasswordErrorSelector,
    resetPasswordLoading,
    resetPasswordSuccessSelector
} from "features/pages/account/reset-password/selectors";
import {resetPasswordStart} from "features/pages/account/reset-password/reducer";
import {Redirect} from "react-router";

/* istanbul ignore next */
const mapStateToProps = state => ({
    loading: resetPasswordLoading(state),
    success: resetPasswordSuccessSelector(state),
    error: resetPasswordErrorSelector(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    resetPasswordStart
};

export const ResetPasswordPage = (props) => {

    const { match: {params: {token} }, loading, error, success } = props;
    const {resetPasswordStart} = props;

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const validatePassword = useCallback((val) => {
        return PasswordValidator(val) ? null : __("validator.invalid-password");
    }, []);
    const checkPassword = useCallback(() => {
        return password === confirmPassword ? null : __("validator.password-no-match");
    }, [password, confirmPassword]);

    const handleResetPassword = useCallback(() => {
        resetPasswordStart({token, password});
    }, [resetPasswordStart, token, password]);

    const renderSuccess = useMemo(() => {
        if(!success) return null;
        return <Redirect to={"/reset-success"} />
    }, [success]);

    return <LoggedOutLayout type={"dark"} className={"reset-password-page"}>
        <Modal>
            <Title size={34} align={"center"}>{__("reset-password.title")}</Title>
            <Text size={16} align={"center"}>{__("reset-password.text")}</Text>
            <div className="field-box">
                <PasswordTextField
                    value={password}
                    onChange={setPassword}
                    placeholder={__("text-fields.password.placeholder")}
                    hint={__("text-fields.password.hint")}
                    validationFunc={validatePassword}
                />
                <PasswordTextField
                    value={confirmPassword}
                    onChange={setConfirmPassword}
                    placeholder={__("text-fields.confirm-password.placeholder")}
                    hint={__("text-fields.confirm-password.hint")}
                    validationFunc={(val) => {
                        return validatePassword(val) || checkPassword()
                    }}
                />
            </div>
            <Button title={__("buttons.send")} disabled={password === "" || password !== confirmPassword} onClick={handleResetPassword} status={loading ? "loading" : null} icon={"arrow-right"} />
            {error.inError && <Text size={16} color={"danger"}>{__(error.error)}</Text>}
            {renderSuccess}
        </Modal>
    </LoggedOutLayout>
}
export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage);
